(()=>{
  const root=document.querySelector('[data-antar-collection]');
  if(!root)return;

  const sections=[...root.querySelectorAll('[data-antar-product-section]')];
  const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile=window.matchMedia&&window.matchMedia('(max-width: 749px)');

  const accessRail=root.querySelector('.antar-collection-access-features');
  const accessCards=accessRail?[...accessRail.querySelectorAll('.antar-collection-access-feature')]:[];
  if(accessRail&&accessCards.length&&mobile?.matches){
    let activeIndex=0;
    let paused=false;
    let inView=true;
    let scrollFrame=0;

    const setActive=index=>{
      activeIndex=Math.max(0,Math.min(index,accessCards.length-1));
      accessCards.forEach((card,cardIndex)=>card.classList.toggle('is-mobile-active',cardIndex===activeIndex));
    };
    const nearestIndex=()=>{
      const target=accessRail.scrollLeft;
      let closest=0;
      let distance=Infinity;
      accessCards.forEach((card,index)=>{
        const cardLeft=card.offsetLeft-accessRail.offsetLeft;
        const nextDistance=Math.abs(cardLeft-target);
        if(nextDistance<distance){distance=nextDistance;closest=index;}
      });
      return closest;
    };
    const syncActive=()=>{
      scrollFrame=0;
      setActive(nearestIndex());
    };
    const goTo=index=>{
      const next=(index+accessCards.length)%accessCards.length;
      const card=accessCards[next];
      if(!card)return;
      setActive(next);
      accessRail.scrollTo({left:card.offsetLeft-accessRail.offsetLeft,behavior:reduced?'auto':'smooth'});
    };
    const clearPressed=()=>accessCards.forEach(card=>card.classList.remove('is-mobile-pressed'));

    setActive(0);
    accessRail.addEventListener('scroll',()=>{
      if(scrollFrame)return;
      scrollFrame=requestAnimationFrame(syncActive);
    },{passive:true});
    accessRail.addEventListener('pointerdown',event=>{
      paused=true;
      clearPressed();
      event.target.closest('.antar-collection-access-feature')?.classList.add('is-mobile-pressed');
    },{passive:true});
    ['pointerup','pointercancel','lostpointercapture'].forEach(type=>accessRail.addEventListener(type,()=>{
      clearPressed();
      paused=false;
      syncActive();
    },{passive:true}));

    if('IntersectionObserver' in window){
      const accessObserver=new IntersectionObserver(entries=>{
        inView=entries.some(entry=>entry.isIntersecting&&entry.intersectionRatio>.35);
      },{threshold:[0,.35,.65]});
      accessObserver.observe(accessRail);
    }

    if(!reduced){
      window.setInterval(()=>{
        if(paused||!inView||document.hidden||!mobile.matches)return;
        goTo(activeIndex+1);
      },3800);
    }
  }

  if(sections.length){
    if(reduced){
      sections.forEach(section=>section.classList.add('is-visible'));
    }else{
      root.classList.add('is-motion-ready');
      if('IntersectionObserver' in window){
        const observer=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{
            if(entry.isIntersecting){
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
        sections.forEach(section=>observer.observe(section));
      }else{
        sections.forEach(section=>section.classList.add('is-visible'));
      }
    }
  }

  const getVariants=panel=>{
    if(panel._antarVariants)return panel._antarVariants;
    const source=panel.querySelector('[data-antar-variant-data]');
    try{
      panel._antarVariants=source?JSON.parse(source.textContent):[];
    }catch(error){
      panel._antarVariants=[];
      console.error('Antar variant data could not be read',error);
    }
    return panel._antarVariants;
  };

  const accessLabel=access=>{
    if(!access?.valid)return '';
    const days=Number(access.days);
    const units=Number(access.units);
    if(!(days>=1&&units>=1))return '';
    if(units===1)return `${days} ${days===1?'day':'days'} of Antar included`;
    return `${units} separate ${days}-day Antar access entitlements included`;
  };

  const accessCommerceNote=variant=>{
    const label=accessLabel(variant?.antarAccess);
    if(!label)return 'Free delivery across India · 30-day returns on eligible physical products';
    return `${label}${variant.antarAccess.giftable?' · Giftable before redemption':''} · Free delivery across India`;
  };

  const syncVariant=panel=>{
    const groups=[...panel.querySelectorAll('[data-antar-option-group]')]
      .sort((a,b)=>Number(a.dataset.position)-Number(b.dataset.position));
    const selected=groups.map(group=>group.querySelector('[data-antar-option]:checked')?.value||'');
    const variants=getVariants(panel);
    groups.forEach((group,groupIndex)=>{
      group.querySelectorAll('[data-antar-option]').forEach(input=>{
        const candidate=[...selected];
        candidate[groupIndex]=input.value;
        const candidateVariant=variants.find(item=>item.options.length===candidate.length&&item.options.every((value,index)=>value===candidate[index]));
        const unavailable=Boolean(candidateVariant&&!candidateVariant.available);
        const label=input.nextElementSibling;
        if(label){label.classList.toggle('is-unavailable',unavailable);label.setAttribute('aria-disabled',String(unavailable));}
        input.disabled=unavailable&&!input.checked;
      });
    });
    const variant=variants.find(item=>item.options.length===selected.length&&item.options.every((value,index)=>value===selected[index]));
    const selectionSummary=panel.querySelector('[data-antar-collection-selection]');
    const selectionText=panel.querySelector('[data-antar-collection-selection-text]');
    const selectionStatus=panel.querySelector('[data-antar-collection-selection-status]');
    if(selectionText)selectionText.textContent=selected.filter(Boolean).join(' · ');
    if(selectionSummary)selectionSummary.classList.toggle('is-unavailable',!(variant&&variant.available));
    if(selectionStatus)selectionStatus.textContent=!variant?'Combination unavailable':variant.available?'Ready to add':'Sold out';
    const form=panel.querySelector('[data-antar-variant-form]');
    const idInput=form?.querySelector('[data-antar-variant-id]');
    const addButton=form?.querySelector('[type="submit"]');
    const addLabel=form?.querySelector('[data-antar-add-label]');
    const addPrice=form?.querySelector('[data-antar-add-price]');
    const chapter=panel.closest('[data-antar-product-section]');
    const livePrice=chapter?.querySelector('[data-antar-live-price]');
    const liveCompare=chapter?.querySelector('[data-antar-live-compare]');
    const mainImage=chapter?.querySelector('[data-antar-main-image]');
    const mediaLabel=chapter?.querySelector('[data-antar-media-variant]');
    const productLinks=chapter?[...chapter.querySelectorAll('[data-antar-product-link]')]:[];
    const commerceNote=chapter?.querySelector('[data-antar-collection-commerce-note]');
    const accessChip=chapter?.querySelector('[data-antar-product-access-chip]');

    if(!variant){
      if(commerceNote)commerceNote.textContent='Free delivery across India · 30-day returns on eligible physical products';
      if(addButton)addButton.disabled=true;
      if(addLabel)addLabel.textContent='Combination unavailable';
      if(addPrice)addPrice.textContent='';
      return;
    }

    if(idInput)idInput.value=variant.id;
    if(addButton)addButton.disabled=!variant.available;
    if(addLabel)addLabel.textContent=variant.available?'Add selected to bag':'Currently unavailable';
    if(addPrice)addPrice.textContent=variant.price||'';
    if(livePrice)livePrice.textContent=variant.price||'';
    if(liveCompare){
      liveCompare.textContent=variant.compareAt||'';
      liveCompare.hidden=!variant.compareAt;
    }
    if(commerceNote)commerceNote.textContent=accessCommerceNote(variant);
    if(accessChip){
      const selectedAccess=accessLabel(variant?.antarAccess);
      accessChip.hidden=!selectedAccess;
      if(selectedAccess)accessChip.textContent=selectedAccess.replace(' of Antar included',' inside Antar').replace(' Antar access entitlements included',' Antar access passes included');
    }

    if(variant.url){
      productLinks.forEach(link=>link.href=variant.url);
    }

    if(mediaLabel&&variant.label){
      mediaLabel.textContent=variant.label;
    }

    if(!root.classList.contains('antar-collection--namastra')&&mainImage&&variant.media?.src&&mainImage.dataset.antarMediaSrc!==variant.media.src){
      const applyMedia=()=>{
        mainImage.classList.add('is-switching');
        requestAnimationFrame(()=>{
          mainImage.src=variant.media.src;
          if(variant.media.srcset)mainImage.srcset=variant.media.srcset;
          if(variant.media.alt)mainImage.alt=variant.media.alt;
          if(variant.media.width)mainImage.width=variant.media.width;
          if(variant.media.height)mainImage.height=variant.media.height;
          mainImage.dataset.antarMediaSrc=variant.media.src;
          requestAnimationFrame(()=>requestAnimationFrame(()=>mainImage.classList.remove('is-switching')));
        });
      };
      const preload=new Image();
      preload.onload=applyMedia;
      preload.onerror=applyMedia;
      preload.src=variant.media.src;
    }
  };

  root.addEventListener('click',event=>{
    const toggle=event.target.closest('[data-antar-options-toggle]');
    if(!toggle||!root.contains(toggle))return;

    const panel=document.getElementById(toggle.getAttribute('aria-controls'));
    if(!panel)return;

    const opening=toggle.getAttribute('aria-expanded')!=='true';
    toggle.setAttribute('aria-expanded',String(opening));
    clearTimeout(panel._antarHideTimer);

    if(opening){
      panel.hidden=false;
      requestAnimationFrame(()=>panel.classList.add('is-open'));
      syncVariant(panel);
    }else{
      panel.classList.remove('is-open');
      panel._antarHideTimer=setTimeout(()=>{
        if(!panel.classList.contains('is-open'))panel.hidden=true;
      },320);
    }
  });

  root.addEventListener('change',event=>{
    if(!event.target.matches('[data-antar-option]'))return;
    const panel=event.target.closest('[data-antar-options-panel]');
    if(panel)syncVariant(panel);
  });

  root.querySelectorAll('[data-antar-options-panel]').forEach(syncVariant);
})();
